<template>
  <div id="faixa-app" class="row m-0 p-0">
    <div class="col m7 s12 offset-l6 m5 text-center">
      <div class="d-none d-lg-block" style="padding: 50px"></div>
      <h1 class="mb-1">APP GH CLUB</h1>
      <p>Todos os benefícios no seu smartphone</p>

      <div class="row mx-auto mt-lg-4 pt-lg-5" style="max-width: 550px">
        <a
          class="mx-auto"
          target="_blank"
          href="https://play.google.com/store/apps/details?id=br.com.ioasys.donuz"
        >
          <img class="responsive-img" src="../assets/img/btn/btn-play-store-170.png" />
        </a>
        <a
          class="mx-auto mt-4 mt-sm-0"
          target="_blank"
          href="https://itunes.apple.com/ca/app/meus-pontos-cartao-fidelidade/id969192544?mt=8"
        >
          <img class="responsive-img" src="../assets/img/btn/btn-app-store-170.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
h1 {
  color: #bbbbbb;
}

p {
  color: #cdc7a8;
  font-size: 18pt;
  padding-top: 0px;
  margin-top: 0px;
}

img {
  margin: 0px 15px 0px 15px;
}

/* @media (min-width: 768px) {
  #faixa-app {
    background-image: url("../assets/img/banner-app-2.png");
    height: 257px;
    background-size: cover;
  }
}

@media (min-width: 1100px) {
  #faixa-app {
    background-image: url("../assets/img/banner-app.png");
    height: 545px;
    background-size: cover;
  }
} */
</style>
